import { type PackageContextType } from "@booking/types";
import { createContext } from "react";

export const PackageContext = createContext<PackageContextType>({
  packageId: 0,
});
